import type {AddComponentTypeOptions, ComponentDefinition} from 'grapesjs';
import {FORM_ERROR_BOX_STYLES} from '@FormMakerReact/components/component-styles';
import {POSTERMYWALL_FORM_BACKGROUND_TYPE} from '@FormMakerReact/components/postermywall-form-background/postermywall-form-background';
import {ICON_VECTOR_ERROR_BOX_SVG, POSTERMYWALL_ICON_VECTOR_TYPE} from '@FormMakerReact/components/postermywall-icon-vector/postermywall-icon-vector';
import {POSTERMYWALL_HEADING_TEXT_TYPE} from '@FormMakerReact/components/postermywall-heading-text/postermywall-heading-text';
import {POSTERMYWALL_FORM_TEXT_TYPE} from '@FormMakerReact/components/postermywall-form-text/postermywall-form-text';

export const POSTERMYWALL_ERROR_BOX_TYPE = 'postermywall-error-box';

const DATA_ATTR = 'data-is-pmw-error-box';

export function buildDefaultErrorBoxChildren(): ComponentDefinition[] {
  return [
    {
      type: POSTERMYWALL_FORM_BACKGROUND_TYPE,
      components: [
        {type: POSTERMYWALL_ICON_VECTOR_TYPE, content: ICON_VECTOR_ERROR_BOX_SVG},
        {type: POSTERMYWALL_HEADING_TEXT_TYPE, content: window.i18next.t('pmwjs_something_went_wrong')},
        {type: POSTERMYWALL_FORM_TEXT_TYPE, content: window.i18next.t('pmwjs_please_try_again')},
      ],
    },
  ];
}

export const POSTERMYWALL_ERROR_BOX: AddComponentTypeOptions = {
  isComponent: (el: HTMLElement) => {
    if (typeof el.getAttribute !== 'function') {
      return undefined;
    }
    return el.tagName === 'DIV' && el.getAttribute(DATA_ATTR) !== null ? {type: POSTERMYWALL_ERROR_BOX_TYPE} : undefined;
  },
  model: {
    defaults: {
      tagName: 'div',
      toolbar: [],
      copyable: false,
      draggable: false,
      droppable: false,
      hoverable: false,
      selectable: false,
      highlightable: false,
      badgable: false,
      style: FORM_ERROR_BOX_STYLES,
      attributes: {
        [DATA_ATTR]: '1',
        id: POSTERMYWALL_ERROR_BOX_TYPE,
      },
    },
  },
};
